import {
  COPILOT_MAIN_AGENT_LABEL,
  DataMessageTypeEnum,
  type TerraUIMessage,
} from '@terra/shared-dto-chat-types';

export type LastCompaction = {
  tokensBefore: number | null;
  tokensAfter: number | null;
  durationMs: number | null;
};

export type CompactionActivity = {
  isCompacting: boolean;
  compactionCount: number;
  lastCompaction: LastCompaction | null;
  streamingSummary: string | null;
};

type LooseCompactionData = {
  type?: unknown;
  agent?: unknown;
  status?: unknown;
  tokensBefore?: unknown;
  tokensAfter?: unknown;
  durationMs?: unknown;
  summary?: unknown;
};

const readNumberOrNull = (value: unknown): number | null =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

export const readCompactionActivity = (
  messages: TerraUIMessage[],
): CompactionActivity => {
  let lastStatus: string | null = null;
  let compactionCount = 0;
  let lastCompaction: LastCompaction | null = null;
  let streamingSummary: string | null = null;

  for (const message of messages) {
    for (const part of message.parts ?? []) {
      const data = (part as { data?: LooseCompactionData | null }).data;

      if (
        !data ||
        data.type !== DataMessageTypeEnum.Compaction ||
        data.agent !== COPILOT_MAIN_AGENT_LABEL ||
        typeof data.status !== 'string'
      ) {
        continue;
      }

      lastStatus = data.status;

      if (data.status === 'started') {
        streamingSummary = null;
      }

      if (data.status === 'streaming') {
        streamingSummary =
          typeof data.summary === 'string' ? data.summary : null;
      }

      if (data.status === 'completed' || data.status === 'failed') {
        streamingSummary = null;
      }

      if (data.status === 'completed') {
        compactionCount += 1;
        lastCompaction = {
          durationMs: readNumberOrNull(data.durationMs),
          tokensAfter: readNumberOrNull(data.tokensAfter),
          tokensBefore: readNumberOrNull(data.tokensBefore),
        };
      }
    }
  }

  const isCompacting = lastStatus === 'started' || lastStatus === 'streaming';

  return {
    compactionCount,
    isCompacting,
    lastCompaction,
    streamingSummary: isCompacting ? streamingSummary : null,
  };
};
